export default __webpack_public_path__ + "static/media/conscent_logo_black.f9885862.svg";